import React from 'react';
import styled from 'styled-components';
import ContactSection from '../components/ContactSection';

const PageContainer = styled.div`
  padding-top: var(--header-h); /* Header yüksekliği kadar boşluk */
  min-height: 100vh;
`;

const ContactPage: React.FC = () => {
  return (
    <PageContainer>
      <ContactSection />
    </PageContainer>
  );
};

export default ContactPage;
